let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("em8WG")).then(() => parcelRequire('23ZvC'));